module.exports = __webpack_public_path__ + "media/images/official/top_mv4_pc-af95ca32a3303125704d006fe6f6f8b5.jpg";